import { Box } from '@mui/material';
import { useStyles } from './CheckIDs.styles';
import { Icons } from '../../../../../../icons';
import { Badge, badgeType } from '../../../../../atoms/badge';
import { btnType, Button } from '../../../../../atoms/button';
import { IconButton } from '../../../../../molecules/icon-button';
import FaceIdScan from '../../../../../../icons/lotties/lottieIcons/FaceIdScan';
import LoveCare from '../../../../../../icons/lotties/lottieIcons/LoveCare';
import { colors } from '../../../../../../colors';

const CheckIDs = ({ promptsVisible, idCardFront, idCardBack }) => {
  const classes = useStyles();
  const hasID = idCardFront && idCardBack;
  return (
    <Box className={classes.container}>
      <Box className={classes.welcomeFrame}>
        <Box display="flex" flexDirection="column" flexGrow={1} flex={1} gap="4px">
          <p className={classes.sectionTitle}>Double-check their ID</p>
          <p className={classes.sectionSubtitle}>
            {hasID ? (
              <>We have one on file, but it’s always good to check.</>
            ) : (
              <>
                We <span className={classes.danger}>do not</span> have their ID on file, make sure you check
                it now.
              </>
            )}
          </p>
        </Box>
        <FaceIdScan className={classes.animatedIcon} />
      </Box>
      <Box className={classes.askBox}>
        <Box className={classes.contentHeader}>
          <Icons glyph={'chat-outlined'} className={classes.sayIcon} />
          <p className={classes.firstLine}>
            You may want to <span style={{ fontWeight: 700, color: colors.success600 }}>say</span> things
            like:
          </p>
        </Box>
        <Box className={classes.askContent}>
          <Box className={classes.instruction} sx={{ backgroundColor: colors.success100 }}>
            We may be prescribing you medications and it’s important that we double-check your identity before
            doing so. Please make sure to upload your ID into the system. Do you have your ID available now?
          </Box>
        </Box>
      </Box>
      <Box className={classes.idBox}>
        <Box className={classes.idBoxContent}>
          <p className={classes.idBoxTitle}>Front</p>
          <Box className={classes.imageBox}>
            {idCardFront ? (
              <img src={idCardFront} alt={'ID Card Front'} className={classes.cardImage} />
            ) : (
              <p className={classes.missingText}>Missing</p>
            )}
          </Box>
        </Box>
        <Box className={classes.idBoxContent}>
          <p className={classes.idBoxTitle}>Back</p>
          <Box className={classes.imageBox}>
            {idCardBack ? (
              <img src={idCardBack} alt={'ID Card Back'} className={classes.cardImage} />
            ) : (
              <p className={classes.missingText}>Missing</p>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export { CheckIDs };
